import React from 'react'
import { storiesOf } from '@storybook/react'

import MainNavigationBar from 'components/MainNavigationBar/MainNavigationBar'

storiesOf('MainNavigationBar', module)
  .add('default', () => (
    <MainNavigationBar />
  ))
  .add('with account info', () => (
    <MainNavigationBar accountInfo={{ balance: [{ value: 21342 }], userName: 'John Doe' }} />
  ))
